import Box from '@ilg-totallymoney/ui/components/Box'
import Flex from '@ilg-totallymoney/ui/components/Flex'
import Heading from '@ilg-totallymoney/ui/components/Heading'
import Text from '@ilg-totallymoney/ui/components/Text'

import BackgroundImageRenderer from '@components/BackgroundImageRenderer'

import LandingPageCtaBackgroundMobile from '@images/credit-cards-landing-page-cta-background-mobile.png'
import LandingPageCtaBackgroundTabletPlus from '@images/credit-cards-landing-page-cta-background.png'

import LandingPageButton from '../LandingPageButton'

interface LandingPageCtaProps {
    heading: string
    link: {
        text: string
    }
    text: string
}

const LandingPageCta = ({
    heading,
    text,
    link: { text: linkText },
}: LandingPageCtaProps) => {
    return (
        <Flex
            as="section"
            backgroundColor="warmYellow60"
            overflow="hidden"
            position="relative"
            borderRadius="borderRadius30"
        >
            <BackgroundImageRenderer
                altText="Call to action background"
                backgroundMobile={LandingPageCtaBackgroundMobile}
                backgroundTabletPlus={LandingPageCtaBackgroundTabletPlus}
                sizes="60vw"
            />

            <Flex
                zIndex={2}
                py={['space40', 'space30', 'space60']}
                px={['space20', 'space60', 'space130']}
                flexDirection="column"
                alignItems="center"
                width="100%"
                aria-disabled="false"
            >
                <Box mb="space10">
                    <Heading variant="100" textAlign="center">
                        {heading}
                    </Heading>
                </Box>

                <Box mb="space30">
                    <Text variant="140" textAlign="center">
                        {text}
                    </Text>
                </Box>

                <Flex
                    justifyContent="center"
                    minWidth={['183px', '272px']}
                    width="100%"
                >
                    <LandingPageButton title={linkText} variant="primary" />
                </Flex>
            </Flex>
        </Flex>
    )
}

export default LandingPageCta
